export const BRIDGE_EVENT = 'bridgeEvent'

export enum BRIDGE_ERROR_CODE {
  UNKNOWN = 'UNKNOWN',
  CLOSE = 'CLOSE',
  INVALID_MESSAGE = 'INVALID_MESSAGE',
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  SECURE_CONFIRMATION_CANCELED = 'SECURE_CONFIRMATION_CANCELED',
}
